import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/coach-business-builder")({
  staticData: { title: "Coach Business Builder" },
  component: () => <Outlet />,
});
